import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=4427d031&scoped=true&"
import script from "./LoadData.vue?vue&type=script&lang=js&"
export * from "./LoadData.vue?vue&type=script&lang=js&"
import style0 from "./LoadData.vue?vue&type=style&index=0&id=4427d031&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427d031",
  null
  
)

export default component.exports